import { MotionGalleryWrapper } from "../../../../src/components/motion-gallery";
import { graphql } from 'gatsby';
import * as React from 'react';
export default {
  MotionGalleryWrapper,
  graphql,
  React
};